/**
 * Fixed UI copy of „Môj profil“ (Figma 60321:19067, mobile 60459:88651). Labels the core dictionary
 * has word for word (Meno, Priezvisko, E-mail, Telefón, Mesto, Krajina, Fakturačná adresa, Údaje o
 * firme, Uložiť zmeny …) are read with `t()` in the components and the address / company wording is
 * shared with the registration (`REGISTER_COPY`); the rest is not administration content and has no
 * dictionary key, so it lives here.
 */
export const PROFILE_COPY = {
  accountType: 'Typ konta',
  emailHint: 'Prihlasovací e-mail meníme len na vyžiadanie.',
  emailChange: {
    text: 'Potrebujete zmeniť e-mail? Napíšte nám z pôvodnej adresy alebo zavolajte – zmenu overíme a urobíme za vás.',
    link: 'Kontaktovať podporu',
  },
  sameDelivery: 'Doručovacia adresa je rovnaká ako fakturačná',
  communication: 'Komunikácia a súhlasy',
  newsletter: {
    title: 'Novinky a zľavy e-mailom',
    text: 'Akcie a kupóny maximálne raz týždenne',
    pending: (email: string) => `Odber potvrďte odkazom, ktorý sme poslali na ${email}.`,
    /** Subscribed, but the API sent no unsubscribe link for the profile. */
    unsubscribeByEmail: 'Odber zrušíte odkazom v ktoromkoľvek newsletteri.',
  },
  saveFailed: 'Zmeny sa nepodarilo uložiť. Skúste to znova.',
  deleteAccount: {
    action: 'Zrušiť konto',
    title: 'Naozaj chcete zrušiť konto?',
    text: 'Konto zrušíme a odhlásime vás. Túto akciu nie je možné vrátiť späť.',
    keep: 'Ponechať konto',
    failed: 'Konto sa nepodarilo zrušiť. Skúste to znova alebo nás kontaktujte.',
  },
} as const;
